import { render, staticRenderFns } from "./OrganismCreateEditCommands.vue?vue&type=template&id=1b59c069&scoped=true&"
import script from "./OrganismCreateEditCommands.vue?vue&type=script&lang=js&"
export * from "./OrganismCreateEditCommands.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCreateEditCommands.vue?vue&type=style&index=0&id=1b59c069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59c069",
  null
  
)

export default component.exports